<script>
import metricsData from "@/data/metricsData.json";
export default {
  name: "chart-legend",
  props: ["id"],
  data() {
    return {
      metrics: metricsData,
      item: null
    };
  },
  async mounted() {
    let item = this.metrics.filter(obj => obj.tooltip == this.id);
    // console.log(item);
    this.item = item && item.length > 0 ? item[0] : null;
  }
};
</script>

<template>
  <div v-if="item">
    <strong>{{ item.text }}</strong> {{ item.description }}
  </div>
</template>
